import React, { useEffect, useState } from "react";
import usePathRunSamples from "../../hooks/usePathRunSamples";
import { formatRunDate, runPathIds } from "../../utils/monitoringUtils";
import PathRunCharts from "./PathRunCharts";

const terminalStatuses = new Set(["completed", "completed_with_errors", "failed", "submission_failed"]);

export default function MonitoringRunCard({ collectionId, run, paths, initiallyOpen = false }) {
  const pathIds = runPathIds(run);
  const [isOpen, setIsOpen] = useState(initiallyOpen);
  const [selectedPathId, setSelectedPathId] = useState(pathIds[0] || "");
  useEffect(() => {
    if (!pathIds.includes(selectedPathId)) setSelectedPathId(pathIds[0] || "");
  }, [pathIds, selectedPathId]);
  const selectedPath = paths.find((path) => path.id === selectedPathId) || { id: selectedPathId, name: selectedPathId };
  const sampleStore = usePathRunSamples(isOpen ? collectionId : "", selectedPathId, run.id);
  const status = run.status || "scheduled";
  const expected = run.expected_sample_count || 0;
  const completed = run.completed_sample_count || 0;
  const progress = expected ? Math.min(100, (completed / expected) * 100) : 0;

  return (
    <article className={`dc-run-card status-${status}`}>
      <button className="dc-run-summary" type="button" onClick={() => setIsOpen((open) => !open)}>
        <span className="dc-run-chevron">{isOpen ? "⌄" : "›"}</span>
        <span className="dc-run-title"><strong>{formatRunDate(run.created_at)}</strong><small>Run {run.id}</small></span>
        <span className="dc-run-stats"><strong>{status.replaceAll("_", " ")}</strong><small>{completed}{expected ? ` of ${expected}` : ""} samples · {pathIds.length} path{pathIds.length === 1 ? "" : "s"}</small></span>
      </button>
      {!terminalStatuses.has(status) && <div className="dc-run-progress"><span style={{ width: `${progress}%` }} /></div>}
      {isOpen && <div className="dc-run-body">
        <div className="dc-run-config">
          <span><small>Duration</small><strong>{run.effective_duration_minutes || run.config?.duration_minutes || "—"} min</strong></span>
          <span><small>Sampling interval</small><strong>{run.effective_polling_interval_seconds || run.config?.polling_interval_seconds || "—"} sec</strong></span>
          <span><small>Route errors</small><strong>{run.route_error_count || 0}</strong></span>
          <span><small>Skipped samples</small><strong>{run.skipped_sample_count || 0}</strong></span>
        </div>
        {pathIds.length ? <>
          <div className="dc-run-path-tabs">
            {pathIds.map((pathId) => {
              const path = paths.find((candidate) => candidate.id === pathId);
              return <button className={pathId === selectedPathId ? "active" : ""} key={pathId} type="button" onClick={() => setSelectedPathId(pathId)}>{path?.name || pathId}</button>;
            })}
          </div>
          <PathRunCharts collectionId={collectionId} runId={run.id} path={selectedPath} {...sampleStore} />
        </> : <div className="dc-chart-state">This run does not list any paths.</div>}
      </div>}
    </article>
  );
}

